import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {MvsCrudService} from "../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {AppointmentService} from "../../../../service/api/appointment.service";
import {AppointmentReasonTypeDto} from "../../../../model/dto/entity/appointment-reason-type.dto";
import {ConfirmationService} from "primeng/api";
import {MvsObjectNavigationService} from "../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";
import {MvsObjectNavigationEntry} from "../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";

@Component({
    selector: 'as-appointment-cancel-appointment',
    templateUrl: 'as-appointment-cancel-appointment.component.html',
    standalone: false
})
export class AsAppointmentCancelAppointmentComponent implements OnInit, OnChanges, OnDestroy {

    appointmentReasonService: MvsCrudService;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() appointmentId: number;
    @Input() createTicket: boolean;
    @Output() onAppointmentDelete: EventEmitter<boolean> = new EventEmitter();

    reasons: AppointmentReasonTypeDto[] = [];

    selectedReason: AppointmentReasonTypeDto;
    comment: string = '';


    constructor(
        protected coreService: MvsCoreService,
        
        protected appointmentService: AppointmentService,
        protected navigationService: MvsObjectNavigationService,
        private confirmationService: ConfirmationService) {
        this.appointmentReasonService = this.coreService.getCrudService("as.AppointmentReasonType");

    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.retrieveAppointmentReason();
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    retrieveAppointmentReason() {
        this.appointmentReasonService.list(ObjectRequestList.createSimple(null)).subscribe(res => {
            this.reasons = res.entries;
        });
    }

    confirmCancelAppointment() {
        if (!this.selectedReason) {
            return;
        }

        this.confirmationService.confirm({
            message: 'Sind Sie sicher, dass Sie diesen Termin stornieren möchten?',
            header: 'Stornierung bestätigen',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Ja',
            rejectLabel: 'Nein',
            acceptButtonStyleClass: 'p-button-danger',
            rejectButtonStyleClass: 'p-button-text',
            accept: () => {
                this.cancelAppointment(); // actual logic
            }
        });
    }

    cancelAppointment() {

        if (this.busy) {
            return;
        }

        this.busy = true;


        this.appointmentService.deleteAppointment(this.appointmentId, this.selectedReason.id, this.comment).subscribe(res => {
            this.onAppointmentDelete.emit(!!res);

            if (this.createTicket) {
                this.openTicketDrawer();
            }
            this.busy = false;
        }, error => {
            this.busy = false;
        });

    }

    openTicketDrawer() {
        const entry = MvsObjectNavigationEntry.createNavigationEntry('tm.Ticket', 0, null, null, null, null, MvsObjectNavigationActionEnum.any);
        this.navigationService.navigateTo(entry, 'right')
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        this.refreshComponent();
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
